import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button, Avatar, Dropdown, Space, Typography, Drawer } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined, DashboardOutlined, FileSearchOutlined, CreditCardOutlined, UserOutlined, LogoutOutlined, CloseOutlined, } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useTheme } from 'styled-components';
const { Header, Sider, Content } = Layout;
const { Text } = Typography;
const MainLayout = ({ children }) => {
    const [collapsed, setCollapsed] = useState(false);
    const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { user, logout } = useAuth();
    const theme = useTheme();
    // Check if device is mobile
    useEffect(() => {
        const checkIsMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };
        checkIsMobile();
        window.addEventListener('resize', checkIsMobile);
        return () => window.removeEventListener('resize', checkIsMobile);
    }, []);
    // Close mobile drawer when route changes
    useEffect(() => {
        setMobileDrawerOpen(false);
    }, [location.pathname]);
    const handleMenuClick = (path) => {
        navigate(path);
        if (isMobile) {
            setMobileDrawerOpen(false);
        }
    };
    const menuItems = [
        {
            key: '/dashboard',
            icon: _jsx(DashboardOutlined, {}),
            label: 'Dashboard',
            style: { color: theme.secondaryColor },
            onClick: () => handleMenuClick('/dashboard'),
        },
        {
            key: '/consulta-poliza',
            icon: _jsx(FileSearchOutlined, {}),
            label: 'Consulta de Póliza',
            style: { color: theme.secondaryColor },
            onClick: () => handleMenuClick('/consulta-poliza'),
        },
        // {
        //   key: '/denuncia-siniestros',
        //   icon: <ExclamationCircleOutlined />,
        //   label: 'Denuncia de Siniestros',
        //   style: { color: theme.secondaryColor },
        //   onClick: () => handleMenuClick('/denuncia-siniestros'),
        // },
        // {
        //   key: '/cotizadores',
        //   icon: <CalculatorOutlined />,
        //   label: 'Cotizadores',
        //   style: { color: theme.secondaryColor },
        //   onClick: () => handleMenuClick('/cotizadores'),
        // },
        {
            key: '/pagos',
            icon: _jsx(CreditCardOutlined, {}),
            label: 'Pagos',
            style: { color: theme.secondaryColor },
            onClick: () => handleMenuClick('/pagos'),
        },
    ];
    const userMenuItems = [
        {
            key: 'profile',
            icon: _jsx(UserOutlined, {}),
            label: 'Perfil',
            onClick: () => {
                navigate('/profile');
            },
        },
        // {
        //   key: 'settings',
        //   icon: <SettingOutlined />,
        //   label: 'Configuración',
        //   onClick: () => {
        //     console.log('Navigate to settings');
        //   },
        // },
        {
            type: 'divider',
        },
        {
            key: 'logout',
            icon: _jsx(LogoutOutlined, {}),
            label: 'Cerrar Sesión',
            onClick: async () => {
                try {
                    await logout();
                }
                catch (error) {
                    console.error('Error en logout:', error);
                    navigate('/login');
                }
            },
        },
    ];
    const getSelectedKey = () => {
        const path = location.pathname;
        if (path.startsWith('/consulta-poliza'))
            return '/consulta-poliza';
        if (path.startsWith('/denuncia-siniestros'))
            return '/denuncia-siniestros';
        if (path.startsWith('/cotizadores'))
            return '/cotizadores';
        if (path.startsWith('/pagos'))
            return '/pagos';
        return '/dashboard';
    };
    const renderLogo = (isCollapsed = false) => (_jsx("div", { style: {
            height: 64,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 16,
            padding: '0 16px',
            zIndex: 1100,
            backgroundColor: theme.secondaryColor,
        }, children: _jsx(Text, { strong: true, style: {
                fontSize: isCollapsed ? 14 : 16,
                color: "#fff",
                textAlign: 'center',
            }, children: isCollapsed ? 'CP' : 'Customer Platform' }) }));
    const renderMenu = () => (_jsx(Menu, { mode: "inline", selectedKeys: [getSelectedKey()], items: menuItems, style: {
            border: 'none',
            height: 'calc(100vh - 80px)',
            overflowY: 'auto',
            backgroundColor: "#F0F2F5",
            color: theme.secondaryColor
        } }));
    // Mobile drawer content
    const mobileDrawerContent = (_jsxs("div", { style: { height: '100%', display: 'flex', flexDirection: 'column' }, children: [_jsxs("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '16px',
                    backgroundColor: "#F0F2F5",
                    color: theme.secondaryColor
                }, children: [_jsx(Text, { strong: true, style: { fontSize: 16, color: theme.secondaryColor }, children: "Customer Platform" }), _jsx(Button, { type: "text", icon: _jsx(CloseOutlined, {}), onClick: () => setMobileDrawerOpen(false), className: "touch-target" })] }), _jsx("div", { style: { flex: 1, backgroundColor: theme.backgroundColor }, children: renderMenu() })] }));
    if (isMobile) {
        return (_jsxs(_Fragment, { children: [_jsxs(Layout, { style: { minHeight: '100vh' }, children: [_jsxs(Header, { style: {
                                padding: '0 16px',
                                background: theme.secondaryColor,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                boxShadow: '0 2px 8px 0 rgba(29,35,41,.05)',
                                position: 'sticky',
                                top: 0,
                                zIndex: 1000,
                            }, children: [_jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: '12px' }, children: [_jsx(Button, { type: "text", icon: _jsx(MenuUnfoldOutlined, {}), onClick: () => setMobileDrawerOpen(true), className: "touch-target", style: { fontSize: '18px', color: "#fff" } }), _jsx(Text, { strong: true, style: { fontSize: 16, color: theme.secondaryColor }, children: "CP" })] }), _jsx(Dropdown, { menu: { items: userMenuItems }, placement: "bottomRight", trigger: ['click'], children: _jsx(Avatar, { style: { backgroundColor: theme.secondaryColor, cursor: 'pointer' }, icon: _jsx(UserOutlined, {}), className: "touch-target" }) })] }), _jsx(Content, { style: {
                                padding: '16px',
                                background: '#f5f5f5',
                                minHeight: 'calc(100vh - 64px)',
                            }, children: _jsx("div", { style: {
                                    background: '#fff',
                                    borderRadius: '8px',
                                    padding: '16px',
                                    minHeight: 'calc(100vh - 96px)',
                                }, children: children }) })] }), _jsx(Drawer, { title: null, placement: "left", onClose: () => setMobileDrawerOpen(false), open: mobileDrawerOpen, width: 280, bodyStyle: { padding: 0 }, headerStyle: { display: 'none' }, closable: false, children: mobileDrawerContent })] }));
    }
    // Desktop layout
    return (_jsxs(Layout, { style: { minHeight: '100vh' }, children: [_jsxs(Sider, { trigger: null, collapsible: true, collapsed: collapsed, style: {
                    background: "#F0F2F5",
                    boxShadow: '2px 0 8px 0 rgba(29,35,41,.05)',
                    zIndex: 900,
                }, breakpoint: "lg", collapsedWidth: 80, children: [renderLogo(collapsed), renderMenu()] }), _jsxs(Layout, { children: [_jsxs(Header, { style: {
                            padding: '0 24px 0 0',
                            background: theme.secondaryColor,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            boxShadow: '0 2px 8px 0 rgba(29,35,41,.05)',
                            zIndex: 1000,
                        }, children: [_jsx(Button, { type: "text", icon: collapsed ? _jsx(MenuUnfoldOutlined, {}) : _jsx(MenuFoldOutlined, {}), onClick: () => setCollapsed(!collapsed), style: {
                                    fontSize: '16px',
                                    width: 64,
                                    height: 64,
                                    color: "#fff"
                                } }), _jsxs(Space, { children: [_jsxs(Text, { className: "hidden-xs", style: { color: "#fff" }, children: ["Bienvenido, ", user?.name] }), _jsx(Dropdown, { menu: { items: userMenuItems }, placement: "bottomRight", arrow: true, children: _jsx(Avatar, { style: { backgroundColor: theme.backgroundColor, color: theme.secondaryColor, cursor: 'pointer' }, icon: _jsx(UserOutlined, {}) }) })] })] }), _jsx(Content, { style: {
                            margin: '24px',
                            padding: '24px',
                            background: '#fff',
                            borderRadius: '8px',
                            minHeight: 'calc(100vh - 112px)',
                        }, children: children })] })] }));
};
export default MainLayout;
